const urlSicaiInstaller = 'http://www.digitalfactura.com/contenido/sicai/downloads/Instalador_SICAI33.exe';
const urlDeConectInstaller = 'http://www.digitalfactura.com/contenido/sicai/downloads/Instalador_DeConect.exe';

export {urlSicaiInstaller, urlDeConectInstaller};
